import React, { useEffect, useState, useRef } from "react";
import "./PauseCourse.scss";
import axios from "axios";
import right from "../../../assets/images/icons/right-arrow.svg";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import { addPauseDays, newPauseError, schoolToday, MIN_PAUSE_DAYS, MAX_PAUSE_DAYS } from "./pauseRules";

const PauseCourse = ({ studentPause, studentPauseMsg }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [saving, setSaving] = useState(false);
  const saveLock = useRef(false);
  const [pauseEligibility, setPauseEligibility] = useState(null);
  const [historyError, setHistoryError] = useState(false);
  const [currentPause, setCurrentPause] = useState(null);
  const [extensionDate, setExtensionDate] = useState("");
  const extendPause = async () => {
    if (saveLock.current || !currentPause?.can_extend) return;
    if (!extensionDate || extensionDate <= currentPause.end_date || extensionDate > addPauseDays(currentPause.start_date, MAX_PAUSE_DAYS)) {
      toast.error("Bitte ein späteres Rückkehrdatum wählen. Die gesamte Pause darf höchstens 184 Tage dauern."); return;
    }
    saveLock.current = true; setSaving(true);
    const form = new FormData();
    form.append("pause_history_id", currentPause.pause_history_id);
    form.append("expected_pause_start", currentPause.start_date);
    form.append("expected_pause_end", currentPause.end_date);
    form.append("pause_end", extensionDate); form.append("confirmed", "1");
    const query = new URLSearchParams({ status: localStorage.getItem("session_user_status") || "", login_cookie: localStorage.getItem("session_user_login_cookie") || "", login_user_id: localStorage.getItem("session_user_id") || "", login_action_type: localStorage.getItem("session_user_type") || "", school_id: localStorage.getItem("session_school_id") || "", f: "extendPauseStudentRequest" });
    try {
      const resp = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/?${query}`, form);
      if (resp.data.status === true) { toast.success(resp.data.message); setExtensionDate(""); await pauseHistoryDetails(); }
      else toast.error(resp.data.message || "Verlängerung wurde nicht gespeichert.");
    } catch (error) { toast.error("Verlängerung konnte nicht gespeichert werden. Bitte erneut versuchen."); }
    finally { saveLock.current = false; setSaving(false); }
  };

  const handleStartDateChange = (e) => {
    const selectedDate = e.target.value;

    // Validate the selected date
    if (!selectedDate) {
      toast("Please select a valid start date.");
      return;
    }

    // Set the start date
    setStartDate(selectedDate);

    setEndDate(addPauseDays(selectedDate, MIN_PAUSE_DAYS));
  };

  const pauseCourse = async () => {


    const formData = new FormData();
    formData.append("pause_start", startDate);
    formData.append("pause_end", endDate);

    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");
    const login_school_id = localStorage.getItem("session_school_id");
    const login_user_status = localStorage.getItem("session_user_status");

    if (saveLock.current) return;
    const validationError = newPauseError(startDate, endDate);
    if (validationError) { toast.error(validationError); return; }
    saveLock.current = true;
    setSaving(true);

    const url = `${process.env.REACT_APP_API_BASE_URL}/?&status=${login_user_status}&login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=addPauseStudentRequest&school_id=${login_school_id}`;

    try {
      const resp = await axios.post(url, formData);
      if (resp.data.status === true) {
        toast.success(resp.data.message);
        setStartDate(""); setEndDate("");
        await pauseHistoryDetails();
      } else { toast.error(resp.data.message || 'Pause was not saved. Please try again.'); }
    } catch (error) {
      toast.error('Pause could not be saved. Your dates have been retained.');
    } finally {
      saveLock.current = false;
      setSaving(false);
    }

  };

  const [data, setData] = useState([]);

  const pauseHistoryDetails = async () => {
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");
    const login_user_status = localStorage.getItem("session_user_status");
    const login_school_id = localStorage.getItem("session_school_id");

    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${encodeURIComponent(login_cookie || '')}&login_action_type=${login_action_type}&status=${login_user_status}&login_user_id=${login_user_id}&f=myPauseStudentRequestList&school_id=${login_school_id}`
      );
      if (resp.data.status !== true) { setHistoryError(true); return; }
      setHistoryError(false);
      setCurrentPause(resp.data.current_pause || null);
      setPauseEligibility({ allowed: resp.data.can_request_new_pause, message: resp.data.pause_limit_message });
      if (resp?.data?.data?.length > 0) {
        setData(resp?.data?.data);
      } else {
        setData([]);
      }
    } catch (error) {
      setHistoryError(true);
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    }
  };

  useEffect(() => {
    pauseHistoryDetails();
  }, []);

  return (
    <div className="place_absence_section">
      <ToastContainer />
      <div className="container-fluid">
        <div className="user_detail">
          <div className="place_absence_title">
            <h2>Kurspause</h2>
            <p>Neue Pause: einmal innerhalb von 365 Tagen, frühestens ab morgen, für 21–184 Tage. Das Rückkehrdatum ist dein erster Tag nach der Pause. Dein bezahltes Abo wird um die tatsächlichen Pausentage verlängert. Eine Verlängerung zählt nicht als neue Pause und kostet keine weitere Pausengebühr.</p>
          </div>
        </div>
        <div className="place_absence">
          {currentPause && <div className="place_absence_inner mb-4">
            <h3>Bestehende Pause</h3>
            <p>Beginn: {currentPause.start_date} · Rückkehr: {currentPause.end_date}</p>
            {currentPause.can_extend ? <>
              <label htmlFor="pause-extension">Neues Rückkehrdatum</label>
              <input id="pause-extension" type="date" className="form-control" value={extensionDate} min={addPauseDays(currentPause.end_date, 1)} max={addPauseDays(currentPause.start_date, MAX_PAUSE_DAYS)} onChange={e => setExtensionDate(e.target.value)} />
              <p>Nur die zusätzlichen Pausentage werden gutgeschrieben. Es entsteht keine weitere Gebühr.</p>
              <button type="button" className="btn btn_primary" disabled={saving || !extensionDate || historyError} onClick={extendPause}>{saving ? "Wird gespeichert…" : "Verlängerung bestätigen"}</button>
            </> : <p>Die bisherigen Pausengutschriften werden geprüft. Bitte wende dich für eine Verlängerung an den Empfang.</p>}
          </div>}
          {pauseEligibility?.allowed === true ? (
            <div className="place_absence_inner">
              <div className="place_absence_calender">
                <form className="row">
                  <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                    <label htmlFor="inputStartdate" className="form-label">
                      Pausenbeginn
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputStartdate"
                      value={startDate}
                      min={addPauseDays(schoolToday(), 1)}
                      onChange={handleStartDateChange}
                    />
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                    <div className="arrow_img">
                      <img className="img-fluid" src={right} alt="" />
                    </div>
                  </div>
                  <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                    <label htmlFor="inputEnddate" className="form-label">
                      Rückkehrdatum
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputEnddate"
                      value={endDate}
                      min={startDate ? addPauseDays(startDate, MIN_PAUSE_DAYS) : addPauseDays(schoolToday(), 1)}
                      max={startDate ? addPauseDays(startDate, MAX_PAUSE_DAYS) : ""}
                      onChange={(e) => {
                        const selectedDate = e.target.value;
                        setEndDate(selectedDate);
                      }}
                    />
                  </div>
                </form>
              </div>
              <div className="absent_btn mt-5">
                <button
                  className="btn btn_primary"
                  type="submit"
                  onClick={pauseCourse}
                  disabled={saving}
                >
                  {saving ? "Wird gespeichert…" : "Pause eintragen"}
                </button>
              </div>
            </div>
          ) : (
            <div className="alert alert-danger mt-2" role="alert">
              {historyError ? 'Pause details could not be loaded. Please reload before requesting a pause.' : pauseEligibility?.message || 'Loading pause details…'}
            </div>
          )}
        </div>
      </div>
      <div className="courses_section">
        <div className="container-fluid">
          <div className="my_courses">
            <div className="user_detail">
              <div className="courses_title">
                <h2>Bisherige Pausen</h2>
              </div>
            </div>
            <div className="courses">
              <div className="courses_inner">
                <div className="courses_cards row">
                  {data?.length ? (
                    data?.map((item, index) => (
                      <Link
                        className="courses_card col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                        key={`${index}-Card`}
                      >
                        <div className="courses_card_inner">
                          <div className="courses_detail">
                            <ul className="courses_list">
                              <li className="courses_item">
                                <span>Beginn:</span>
                                <span>{item?.start_date}</span>
                              </li>
                              <li className="courses_item">
                                <span>Rückkehr:</span>
                                <span>{item?.end_date}</span>
                              </li>
                              <li className="courses_item">
                                <span>Erfasst:</span>
                              <span>{item?.requested_date || 'Not recorded'}</span>
                              </li>
                              {/* <li className="courses_item">
                                <span>Status :</span>
                                <span>
                                  {item?.status}
                                </span>
                              </li> */}
                            </ul>
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <Link className="courses_card col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                      <div className="courses_card_inner">
                        <div className="courses_detail">
                          <ul className="courses_list">
                            <li className="courses_item">
                              <span>{historyError ? 'Pause history could not be loaded' : pauseEligibility === null ? 'Loading pause history…' : 'No Pause History Available'}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PauseCourse;
